import React from 'react';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { graphql, useStaticQuery } from 'gatsby';
import { ClassCarousel } from '~/src/components/carousels/ClassCarousel';

import { sortCardsByIds } from '../sortCardsByIds';

interface Props {
  children: (data: React.ComponentProps<typeof ClassCarousel>['items']) => React.ReactNode;
}
const list = [
  // Start the Day	Rodney Yee
  '1QLVkcglMgiOyjCDn0ctnJ',
  // Feel Into the Moment with Colleen Saidman Yee (30, 2, hatha)
  '2NeewMsgzu35OdEE5y2hZk',
  // Move with Tenderness with Oneika Mays (20, 2, slow flow)
  '722Rf5mWpEVJwuOxItD2wP',
  // Everyday Flow Practice with Sue Elkind (60min, 2, vin)
  '59isjXjrzcVaMj37DdkyzB',
  // Wild and Free with Sierra (30, 2, Kun)
  'H4mKdPaK40tfjKjLLtmCV',
  // Everyday Morning Practice with Luke Ketterhagen (20, 2 hatha)
  '14rfFxqrAFN7AsGmAxiV9G',
  // Serene Spine with Nichole Golden (10, 1, hatha)
  '2QsXFa1mkJRY9JQ8Vyzhmb',
  // Your Inner Sanctuary with Nico Luce (45, 2, Yin)
  '5XPYSwGn3Uu0fUNcTACXVE',
  // Good Morning Gratitude with Tiffany Bush (10, 2, vin)
  'SlnHnpCLkvB6ttIPK82RH',
  // Care for Glutes and Piriformis (15, 1, Yoga Therapy)
  '1BpelBfXa7opo3ia4LpvTd',
  // Ease of Movement with Jim Bennitt (30, 2, hatha)
  '7oe1X07TbIvbl9P7QKPxYq',
  // Balm for the Low Back with Corina Benner (10, 1, Slow Flow)
  '5cow1LYRAuGeKfMpncryqq',
];

export const YogaCarouselDataEN: React.FC<Props> = ({ children }) => {
  const yiData = useStaticQuery<gql.typesSsr.Query_AllClasses_LOH_EN>(graphql`
    query Query_AllClasses_LOH_EN {
      yi {
        allClasses(
          filter: {
            ids: [
              "1QLVkcglMgiOyjCDn0ctnJ"
              "2NeewMsgzu35OdEE5y2hZk"
              "722Rf5mWpEVJwuOxItD2wP"
              "59isjXjrzcVaMj37DdkyzB"
              "H4mKdPaK40tfjKjLLtmCV"
              "14rfFxqrAFN7AsGmAxiV9G"
              "2QsXFa1mkJRY9JQ8Vyzhmb"
              "5XPYSwGn3Uu0fUNcTACXVE"
              "SlnHnpCLkvB6ttIPK82RH"
              "1BpelBfXa7opo3ia4LpvTd"
              "7oe1X07TbIvbl9P7QKPxYq"
              "5cow1LYRAuGeKfMpncryqq"
            ]
          }
        ) {
          ...Fragment_ClassCard
        }
      }
    }
  `);

  const data = yiData?.yi?.allClasses;
  if (isNil(data)) {
    return null;
  }
  const sortedClassesData = sortCardsByIds(data, list);

  return <>{children(sortedClassesData)}</>;
};
